import classNames from "classnames";
import InlineLoader from "@/icons/inline-loader.svg";

function BuyNowBtn({ isLoading, onClick }) {
  return (
    <button
      className="w-[180px] h-[60px] lg:w-[232px] lg:h-[76px] bg-[#FF7A00] rounded-2xl transition-colors duration-700 text-xl lg:text-3xl text-white font-extrabold hover:bg-[#CE6A06] relative"
      disabled={isLoading}
      onClick={onClick}
    >
      {isLoading && (
        <InlineLoader className="inline-block h-[4rem] w-[4rem] absolute top-[calc(50%_-_2rem)] left-[calc(50%_-_2rem)]" />
      )}
      <div
        className={classNames(
          {
            invisible: isLoading,
          },
          "block"
        )}
      >
        Buy Now
      </div>
    </button>
  );
}

export default BuyNowBtn;
